import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=a978e508&scoped=true&"
import script from "./inspection.vue?vue&type=script&lang=js&"
export * from "./inspection.vue?vue&type=script&lang=js&"
import style0 from "./inspection.vue?vue&type=style&index=0&id=a978e508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978e508",
  null
  
)

export default component.exports